import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Box from 'components/Box';
import { TeamSectionTitle as Title } from 'components/Text';

import { cxHelpers } from 'util/className';
const { cx } = cxHelpers('WithholdingFormFields');

import FieldRenderer from '../../FieldRenderer';

import {
  COMPONENT_MAPPER,
  DEFAULT_COMPONENT,
  INPUT_TYPE_MAPPER,
} from './constants';

const WithholdingFormFields = ({ form, formIndex, formValues }) => {
  const getParameterComponent = useCallback(
    parameter => COMPONENT_MAPPER[parameter.get('type')] || DEFAULT_COMPONENT,
    []
  );

  const getParameterInputType = useCallback(
    parameter =>
      INPUT_TYPE_MAPPER[parameter.get('type')] || parameter.get('type'),
    []
  );

  return (
    <Box className={cx()}>
      {form.get('parameters').map((parameter, index) => {
        if (
          !parameter.get('depends_on') ||
          (parameter.get('depends_on') &&
            String(formValues[parameter.get('depends_on').get('name')]).match(
              new RegExp(parameter.get('depends_on').get('value_matches'))
            ))
        ) {
          return (
            <Box
              row
              mb={24}
              vcenter
              key={`form-${formIndex}-parameter-${index}`}
            >
              <Box grow basis="40%">
                <Title>{parameter.get('label')}</Title>:
              </Box>
              <Box grow basis="60%">
                <FieldRenderer
                  editMode
                  name={`${parameter.get('name')}`}
                  component={getParameterComponent(parameter)}
                  options={
                    parameter.get('options') && parameter.get('options').toJS()
                  }
                  type={getParameterInputType(parameter)}
                />
              </Box>
            </Box>
          );
        }
        return null;
      })}
    </Box>
  );
};

WithholdingFormFields.propTypes = {
  form: PropTypes.object.isRequired,
  editMode: PropTypes.bool,
  formIndex: PropTypes.number.isRequired,
};

export default WithholdingFormFields;
